import { Locale } from "ias-lib";
import React from "react";

const AccessDenied: React.FunctionComponent = () => {
    return (
        //TODO make component look better than just plain text maybe
        <p>{Locale.trans('error.companyAccessDenied.message')}</p>
    )
}
export default AccessDenied;